import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EarthAmericasFilled"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.4934 6.20375 17.7962 1.50661 12 1.5ZM3 12C3.00205 10.9773 3.17963 9.96259 3.525 9H7.5L11.25 12L9.15 14.7698C8.92613 15.0683 8.95585 15.4861 9.21975 15.75L11.25 18V20.9625C6.59054 20.5693 3.0068 16.676 3 12ZM16.0763 20.0137L17.9858 14.2387C18.0413 13.9602 17.9347 13.6743 17.7105 13.5L11.25 8.24998L12.75 6.74998H16.71C17.0327 6.74974 17.319 6.54313 17.421 6.23698L17.7923 5.12248C20.1035 7.06197 21.2863 10.0325 20.9409 13.0298C20.5955 16.0272 18.768 18.6508 16.0763 20.0137Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EarthAmericasFilled.vue"]]);
